import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {iClient} from '../../../Model/ClientModel';
import {RulesService} from '../../../Services/rules.service';
import {InsuranceService} from '../../../Services/insurance.service';
import {QuestionsService} from '../../../Services/questions.service';

@Component({
  selector: 'pm-add-update-rules',
  templateUrl: './add-update-rules.component.html',
  styleUrls: ['./add-update-rules.component.css']
})

export class AddUpdateRulesComponent implements OnInit {
  rulesRegisterForm!: FormGroup;
  ruleId :any;
  status:any;
  questionList:any =[];
  categoryArray: any = [];
  selectedCategory: any;
  questionsList: any[] = [];
  selectedQuestion: string = '';
  isEditMode: boolean = false;

  nType: any = [
    {value: 'null', viewValue: 'Select Network Type'},
    {value: 'In-Network', viewValue: 'IN Network'},
    {value: 'Out-Of-Network', viewValue: 'Out Network'},
  ];

  pType: any = [
    {value: 'null', viewValue: 'Select Plan Type'},
    {value: 'HMO', viewValue: 'HMO'},
    {value: 'DISCOUNT', viewValue: 'DISCOUNT'},
    {value: 'PPO', viewValue: 'PPO'},
    {value: 'NOT ELIGIBLE', viewValue: 'NOT ELIGIBLE'},
    {value: 'CNID', viewValue: 'CNID'},
    {value: 'TPI', viewValue: 'TPI'},
    {value: 'PREMIER', viewValue: 'PREMIER'},
    {value: 'EPO', viewValue: 'EPO'},
    {value: 'NEED_UPDATE', viewValue: 'NEED UPDATE'},
  ];

  fType: any = [
    {value: 'null', viewValue: 'Select Form Type'},
    {value: 'FULL FORM', viewValue: 'FULL FORM'},
    {value: 'SHORT FORM', viewValue: 'SHORT FORM'},
  ];

  cType: any = [
    {value: 'selectForm', viewValue: 'Select Coloumb'},
    {value: 'AMOUNT', viewValue: 'Amount'},
    {value: 'PERCENT', viewValue: 'Percent'},
    {value: 'LIMITATION', viewValue: 'Limitation'},
    {value: 'DISCLAIMERS', viewValue: 'Disclaimers'},
    {value: 'SERVICENAME', viewValue: 'History'},
  ];

  constructor(private fb: FormBuilder,
              private clientServices: ClientService,
              private insuranceService: InsuranceService,
              private questionService: QuestionsService,
              private rulesServices: RulesService,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private route: Router) {

    this.ruleId = this.activatedRoute.snapshot.paramMap.get('id');

    this.rulesRegisterForm = this.fb.group({
      id:[],
      name: [null, Validators.required],
      desc: [null, Validators.required],
      salience: [null],
      networkType: [null],
      planType: [null],
      formType: [null],
      category: [null],
      question: [null],
      fieldName: [null],
      response: [null]

    });

    /*if(this.ruleId){
      let reqData:any ={
        ruleId : this.ruleId,
        clientId: this.authService.clientId
      }
      this.rulesServices.getRulesDetails(reqData).pipe(first()).subscribe(
          (response: any) => {
            console.log('API Response:', response); // Debugging response
            if (response && response.length > 0 && response[0].id) {
              const data = response[0];
              // this.status = data.active
              this.rulesRegisterForm.patchValue({
                name: data?.ruleName || null,
                desc: data?.description || null,
                salience: data?.salience || null,
                networkType: data?.network || null,
                planType: data?.planType || null,
                formType: data?.formType || null,
                category: data?.category || null,
                question: data?.question || null,
                fieldName: data?.fieldName || null,
                response: data?.response || null,
              });
            } else {

              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: response?.message || 'No data found',
                showConfirmButton: false,
                timer: 5000
              });
            }
          },
          (error) => {
            console.error('API Error:', error);
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error?.message || 'An error occurred',
              showConfirmButton: false,
              timer: 5000
            });
          }
      );
    }*/
    if (this.ruleId) {
      this.isEditMode = true;
      this.getRuleDetails(); // move your API call into its own method
    }
  }

  ngOnInit(): void {
    this.getCategoryDropdown();
  }

  getRuleDetails() {
    const reqData: any = {
      ruleId: this.ruleId,
      clientId: this.authService.clientId
    };

    this.rulesServices.getRulesDetails(reqData).pipe(first()).subscribe(
      (response: any) => {
        if (response && response.length > 0 && response[0].id) {
          const data = response[0];
          this.rulesRegisterForm.patchValue({
            name: data?.ruleName || null,
            desc: data?.description || null,
            salience: data?.salience || null,
            networkType: data?.network || null,
            planType: data?.planType || null,
            formType: data?.formType || null,
            category: data?.category || null,
            question: data?.question || null,
            fieldName: data?.fieldName || null,
            response: data?.response || null,
          });

          // ✅ Now fetch questions list based on patched category
          this.selectedCategory = data.category;
          this._fetchData(data.category, data.question); // Pass question to preselect
        } else {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: response?.message || 'No data found',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      (error) => {
        console.error('API Error:', error);
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error?.message || 'An error occurred',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }


  getCategoryDropdown() {
    this.questionService.getCategoryDropdown().pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.categoryArray = response;
          if (!this.isEditMode) {
            this.selectedCategory = this.categoryArray[0]?.category;
            this.rulesRegisterForm.get('category')?.setValue(this.selectedCategory);
            this._fetchData(this.selectedCategory);
          }

        }
      });
  }

  changeCategory(category:any){
    this.selectedCategory = category?.value;
    this._fetchData(category?.value);
  }

  _fetchData(category?: any, selectedQuestion?: any) {
    const params = { category };
    this.questionService.getQuestionCategoryList(params).pipe(first()).subscribe(
      (response: any) => {
        if (response && response.length > 0) {
          this.questionsList = response;
          /*his.selectedQuestion = this.questionsList[0]?.question;  // Default select first question*/
          if (this.isEditMode && selectedQuestion) {
            this.rulesRegisterForm.get('question')?.setValue(selectedQuestion);
          } else {
            this.selectedQuestion = this.questionsList[0]?.question;
            this.rulesRegisterForm.get('question')?.setValue(this.selectedQuestion);
          }
        }
         else {
          this.questionsList = [];
          this.rulesRegisterForm.get('question')?.reset();
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: response.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      (error) => {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message,
          showConfirmButton: false,
          timer: 5000
        });
      }
    );


  }

  // Change status
  changeStatus(status:any){
    if(status == true){
      this.status = false;
    }else{
      this.status = true;
    }
  }

  // Register client function / update
  onRegister(): any {
    this.rulesRegisterForm.markAllAsTouched();
    if (this.rulesRegisterForm.valid) {
      let reqData = {
        ruleName: this.rulesRegisterForm.controls.name.value,
        description: this.rulesRegisterForm.controls.desc.value,
        network: this.rulesRegisterForm.controls.networkType.value,
        salience: this.rulesRegisterForm.controls.salience.value,
        planType: this.rulesRegisterForm.controls.planType.value,
        formType: this.rulesRegisterForm.controls.formType.value,
        category: this.rulesRegisterForm.controls.category.value,
        question: this.rulesRegisterForm.controls.question.value,
        fieldName: this.rulesRegisterForm.controls.fieldName.value,
        response: this.rulesRegisterForm.controls.response.value,
      };

      // update logic
      if(this.ruleId){
        let params = {
          ruleId: this.ruleId,
          clientId:this.authService.clientId
        }
        this.rulesServices.updateRules(reqData,params).pipe(first()).subscribe(
            (response: any) => {
              if (response != undefined) {
                this.route.navigate(['rules']);
                swal.fire({
                  icon: 'success',
                  // text: 'Rule :- ' + `" ${reqData.ruleName} "`+ ' updated successfully.',
                  showConfirmButton: false,
                  timer: 3000
                });
              } else {
                swal.fire({
                  title: 'Error!',
                  icon: 'error',
                  text: response.message,
                  showConfirmButton: false,
                  timer: 5000
                });
              }
            },
            (error) => {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: error.error.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
        );
      }
      // add / register logic
      else {
        let params={
          clientId: String(this.authService.clientId)
        }
        this.rulesServices.ruleRegistration([reqData], params).pipe(first()).subscribe(
            (response: any) => {
              if (response != undefined) {
                this.route.navigate(['rules']);
                swal.fire({
                  icon: 'success',
                  // text: 'Rule :- ' + `" ${reqData.ruleName} "`+ ' registered successfully.',
                  showConfirmButton: false,
                  timer: 3000
                });
              } else {
                swal.fire({
                  title: 'Error!',
                  icon: 'error',
                  text: response.message,
                  showConfirmButton: false,
                  timer: 5000
                });
              }
            },
            (error) => {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: error.error.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
        );
      }

    }
  }

}
